class ScrollTo {
  constructor() {
    this.button = document.querySelector('.js-scrollto-trigger');
    this.target = document.getElementById(
      this.button.getAttribute('href').substring(1),
    );
    if (this.button && this.target) {
      this.init();
    }
  }

  handleClick = e => {
    e.preventDefault();
    const top = this.target.getBoundingClientRect().top + window.pageYOffset;
    $('html, body').animate({ scrollTop: `${top}px` }, 300);
  };

  bindEventListeners() {
    this.button.addEventListener('click', this.handleClick);
  }

  init() {
    this.bindEventListeners();
  }
}

export default ScrollTo;
